// import React, { useState, useEffect, useRef } from "react";
// import { Helmet } from "react-helmet-async";
// import AOS from "aos";
// import { Home , Eye, Heart } from "lucide-react";
// import aboutimg from '../assets/images/aboutimg.jpg';
// import aboutimg2 from '../assets/images/aboutimg2.webp';
// import bannerImg from "../assets/images/storybanner.webp";
// import { Mousewheel } from "swiper/modules";
// import "swiper/css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css/mousewheel";
// const About = () => {

//   useEffect(() => {
//     AOS.init({
     
//     });
//   }, []);
//   return (
//   <>
    
//     <Helmet>
//         {/* Meta Title */}
//         <title>TheOmSaga: Embark on a Soulful Journey</title>

//         {/* Meta Description */}
//         <meta
//           name="description"
//           content="TheOmSaga is a platform dedicated to spiritual stories from real lives. Learn how this space was created to share faith and miracles."
//         />

//         {/* Primary Keywords */}
//         <meta
//           name="keywords"
//           content="spiritual stories, spiritual tale, spiritual story telling platform"
//         />

//         {/* Canonical Tag */}
//         <link rel="canonical" href="https://theomsaga.com/aboutus" />

//         {/* Open Graph Tags */}
//         <meta
//           property="og:title"
//           content="About TheOmSaga | Spiritual Stories That Inspire Faith"
//         />
//         <meta
//           property="og:description"
//           content="TheOmSaga is a platform dedicated to spiritual stories from real lives. Learn how this space was created to share faith and miracles."
//         />
//         <meta property="og:url" content="https://theomsaga.com/aboutus" />
//         <meta
//           property="og:image"
//           content="https://theomsaga.com/assets/images/storybanner.jpg"
//         />

//         {/* Schema Markup */}
//         <script type="application/ld+json">
//           {`
//           {
//             "@context": "https://schema.org",
//             "@type": "AboutPage",
//             "@id": "https://theomsaga.com/aboutus#aboutpage",
//             "name": "About TheOmSaga",
//             "url": "https://theomsaga.com/aboutus",
//             "description": "TheOmSaga is a spiritual storytelling platform sharing real-life spiritual tales, faith journeys, and miracles to inspire belief and hope."
//           } ,
//             "sameAs": [
//                   "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
//                   "https://www.facebook.com/share/1B44vEtGc7/"
//                 ]
//           `}
//         </script>
//       </Helmet>
    



//       <div>

// <section className="home-main-sec ">

//   <img src={bannerImg} className="home-main-sec-bg" alt="Banner" />

//   <div className="home-main-sec-overlay"></div>

//   <div className="container home-main-sec-content">

//     <h1 className="loop-title">
//     TheOmSaga: Embark on a Soulful Journey
//     </h1>



//   </div>

// </section>




//     {/* <section className="about-page-slide-sec about-page-slide-sec-heading-slide">
//       <div className="container text-center">
//         <p className="about-page-slide-sec-heading-small">Welcome to TheOmSaga – a heartfelt space for spiritual stories that remind you the divine
// is always with you.</p>

//         <p className="about-page-slide-sec-heading-big">
// From simple moments of grace to life-changing miracles, we bring together inspirational
// spiritual stories and real experiences of faith, protection, and hope.
// Here, you’ll find:
//  Indian spiritual stories passed down through families
//  Best spiritual short stories that are easy to read and deep in meaning
//  Motivational spiritual stories that bring courage in difficult times
//  Personal spiritual tales and anecdotes of prayer, devotion, and divine help
//         </p>
//       </div>
//     </section> */}

//     <section className="about-page-slide-sec">
//       <div className="container">
//         <div className="row align-items-center">

//           <div className="col-md-6  order-2 order-lg-1" >
//             <img
//               src={aboutimg2}
//               className="about-page-slide-sec-slide-image"
//               alt="project"
//             />
//           </div>

//           <div className="col-md-6  order-1 order-lg-2">
//             {/* <p className="about-page-slide-sec-slide-small"   data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">About US</p>

//              */}
//             <p className="about-page-slide-sec-slide-para"   data-aos="fade-up" data-aos-delay="400" data-aos-duration="1000">
//           TheOmSaga is a spiritual storytelling platform created for souls who deeply believe in the power of faith, prayer, and divine miracles, and who feel the presence of a supreme energy guiding and protecting them through life’s journey.

// Rooted in the eternal wisdom of Sanatana Dharma, TheOmSaga shares heartfelt spiritual stories and devotional experiences that awaken inner peace, strengthen devotion, and inspire spiritual growth across generations, especially among today’s youth seeking meaning in a fast-changing world.   </p>
           
//           </div>

//         </div>
//       </div>
//     </section>
//  <section   data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000" className="home-lasthero-sec" >
//       <div className="home-lasthero-overlay"></div>

//       <div className="container">
//         <div className="home-lasthero-inner">



//           <p className="home-lasthero-title">
//           Read. Reflect. Share your own story.
//           </p>

//           <p className="home-lasthero-desc">
//            Whether you’re seeking strength, clarity, or peace, these best spiritual stories are here to uplift your heart and reconnect you with faith.
//           </p>

         

//         </div>
//       </div>
//     </section>

// <section className="about-page-slide-sec">
// <div className="container">
// <div className="row align-items-center">

// {/* LEFT CONTENT */}
// <div className="col-md-6">

//   <p className="about-page-slide-sec-slide-small" data-aos="fade-up"  data-aos-duration="400"  >
//     Why This Website Is Unique
//   </p>

// <div className="about-page-point-box">
//     {/* ITEM 1 */}
//   <div className="about-page-slide-sec-point" data-aos="fade-up"  data-aos-duration="400">
//     <p className="about-page-slide-sec-point-title">
//       <FontAwesomeIcon
//         icon={faCheckCircle}
//         className="about-page-slide-sec-check-icon"
//       />
//       Real Stories of Living Faith
//     </p>
//     <p className="about-page-slide-sec-pointslide-para">
//    A platform to share real-life experiences connected to Hindu gods and goddesses—stories of belief, miracles, and personal spiritual journeys.
//     </p>
//   </div>

//   {/* ITEM 2 */}
//   <div className="about-page-slide-sec-point" data-aos="fade-up"  data-aos-duration="400">
//     <p className="about-page-slide-sec-point-title">
//       <FontAwesomeIcon
//         icon={faCheckCircle}
//         className="about-page-slide-sec-check-icon"
//       />
//       Purpose Beyond Storytelling
//     </p>
//     <p className="about-page-slide-sec-pointslide-para">
//       50% of the proceeds go towards charity, making every story shared a
//       meaningful contribution to a noble cause.
//     </p>
//   </div>

//   {/* ITEM 3 */}
//   <div className="about-page-slide-sec-point" data-aos="fade-up"  data-aos-duration="400">
//     <p className="about-page-slide-sec-point-title">
//       <FontAwesomeIcon
//         icon={faCheckCircle}
//         className="about-page-slide-sec-check-icon"
//       />
//       Inspiring Faith & Awareness
//     </p>
//     <p className="about-page-slide-sec-pointslide-para">
//       These experiences inspire belief in the Almighty and encourage
//       spiritual awareness in everyday life.
//     </p>
//   </div>

//   {/* ITEM 4 */}
//   <div className="about-page-slide-sec-point" data-aos="fade-up"  data-aos-duration="400">
//     <p className="about-page-slide-sec-point-title">
//       <FontAwesomeIcon
//         icon={faCheckCircle}
//         className="about-page-slide-sec-check-icon"
//       />
//       Preserving Sacred Legacy
//     </p>
//     <p className="about-page-slide-sec-pointslide-para">
//    Safeguarding the timeless wisdom, values, and divine stories of Hindu deities for generations to come.
//     </p>
//   </div>
// </div>

// </div>

// {/* RIGHT IMAGE */}
// <div className="col-md-6">
//   <img
//     src={aboutimg}
//     className="about-page-slide-sec-slide-image"
//     alt="project"
//   />
// </div>

// </div>
// </div>
// </section>

  


// </div>
    
//     </>
   
//   )
// }

// export default About











import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import {
  Target,
  Eye,
  BookOpen,
  Users,
  HandHeart,
  Leaf,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import bannerImg from "../assets/images/storybanner.webp";
import "aos/dist/aos.css";


const About = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>TheOmSaga: Embark on a Soulful Journey</title>

        <meta
          name="description"
          content="TheOmSaga is a platform dedicated to spiritual stories from real lives. Learn how this space was created to share faith and miracles."
        />

        <meta
          name="keywords"
          content="spiritual stories, spiritual tale, spiritual story telling platform"
        />

        <link
          rel="canonical"
          href="https://theomsaga.com/aboutus"
        />

        <meta
          property="og:title"
          content="About TheOmSaga | Spiritual Stories That Inspire Faith"
        />

        <meta
          property="og:description"
          content="TheOmSaga is a platform dedicated to spiritual stories from real lives. Learn how this space was created to share faith and miracles."
        />

        <meta
          property="og:url"
          content="https://theomsaga.com/aboutus"
        />

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "@id": "https://theomsaga.com/aboutus#aboutpage",
              "name": "About TheOmSaga",
              "url": "https://theomsaga.com/aboutus",
              "description": "TheOmSaga is a spiritual storytelling platform sharing real-life spiritual tales, faith journeys, and miracles to inspire belief and hope.",
              "sameAs": [
                "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                "https://www.facebook.com/share/1B44vEtGc7/"
              ]
            }
          `}
        </script>
      </Helmet>

      <div className="new-about-page">

        {/* =====================================================
            ABOUT PAGE HERO
            NO IMAGE
        ====================================================== */}

        {/* <section className="new-about-page-hero">
          <div className="new-about-page-container">

            <h1 className="new-about-page-hero-title">
              ABOUT THEOMSAGA
            </h1>


          </div>
        </section> */}


 <section className="home-main-sec ">

   <img src={bannerImg} className="home-main-sec-bg" alt="Banner" />

   <div className="home-main-sec-overlay"></div>

  <div className="container home-main-sec-content">

     <h1 className="loop-title">
     TheOmSaga: Embark on a Soulful Journey
    </h1>



  </div>

 </section>
        {/* =====================================================
            ABOUT INTRO
        ====================================================== */}

        <section className="new-about-page-intro">
          <div className="new-about-page-container">

            <div
              className="new-about-page-intro-content"
              data-aos="fade-up"
            >

              <p className="new-about-page-description">
                Founded by professionals from the IT and Sales industry, TheOmSaga is built on the belief that every story has the power to inspire and change a life. We use technology to bring people together through stories of faith, spirituality, life lessons, and hope—while promoting Sanatana Dharma in its true spirit and turning inspiration into meaningful action by supporting those in need.
              
              </p>

           
            </div>

          </div>
        </section>


        {/* =====================================================
            MISSION & VISION
        ====================================================== */}

        <section className="new-about-page-mission-section">
          <div className="new-about-page-container">

            <div className="new-about-page-mission-grid">

              {/* ================= MISSION ================= */}

              <div
                className="new-about-page-info-card"
                data-aos="fade-up"
              >

                <div className="new-about-page-info-top">

                  <div className="new-about-page-info-icon">
                    <Target size={23} />
                  </div>

                  <p className="new-about-page-card-title">
                    Our Mission
                  </p>

                </div>

                <p className="new-about-page-card-description">
                  To preserve meaningful stories and life experiences, promote the values of Sanatana Dharma, and inspire people through stories of faith, resilience, kindness, learning, and hope—creating a positive space where people of all ages can connect, reflect, and grow.
                </p>

              </div>


              {/* ================= VISION ================= */}

              <div
                className="new-about-page-info-card"
                data-aos="fade-up"
                data-aos-delay="150"
              >

                <div className="new-about-page-info-top">

                  <div className="new-about-page-info-icon">
                    <Eye size={23} />
                  </div>

                  <p className="new-about-page-card-title">
                    Our Vision
                  </p>

                </div>

                <p className="new-about-page-card-description">
                  To become a trusted global community where meaningful stories, experiences, and life lessons inspire people, spread positivity, and preserve the timeless values and wisdom of Sanatana Dharma for generations to come.
                </p>

              </div>

            </div>

          </div>
        </section>


        {/* =====================================================
            OUR VALUES
        ====================================================== */}

        <section className="new-about-page-values-section">
          <div className="new-about-page-container">

            <div
              className="new-about-page-section-heading"
              data-aos="fade-up"
            >

              <p className="new-about-page-section-title">
                Our Values
              </p>

              <span className="new-about-page-orange-line"></span>

            </div>


            <div className="new-about-page-values-grid">

              {/* ================= FAITH ================= */}

              <div
                className="new-about-page-value-card"
                data-aos="fade-up"
              >

                <div className="new-about-page-value-icon">
                  <span className="new-about-page-om-icon">
                    ॐ
                  </span>
                </div>

                <p className="new-about-page-value-title">
                  Faith
                </p>

                <p className="new-about-page-value-description">
                  Celebrating faith, spirituality, devotion, and the strength they bring to our lives.
                </p>

              </div>


              {/* ================= AUTHENTICITY ================= */}

              <div
                className="new-about-page-value-card"
                data-aos="fade-up"
                data-aos-delay="100"
              >

                <div className="new-about-page-value-icon">
                  <BookOpen size={24} />
                </div>

                <p className="new-about-page-value-title">
                  Authenticity
                </p>

                <p className="new-about-page-value-description">
                  Sharing real stories, experiences, learnings, and moments that inspire and uplift.
                </p>

              </div>


              {/* ================= COMMUNITY ================= */}

              <div
                className="new-about-page-value-card"
                data-aos="fade-up"
                data-aos-delay="200"
              >

                <div className="new-about-page-value-icon">
                  <Users size={24} />
                </div>

                <p className="new-about-page-value-title">
                  Community
                </p>

                <p className="new-about-page-value-description">
                  Connecting people through stories that motivate, teach, and strengthen the human spirit.
                </p>

              </div>


              {/* ================= SEVA ================= */}

              <div
                className="new-about-page-value-card"
                data-aos="fade-up"
                data-aos-delay="300"
              >

                <div className="new-about-page-value-icon">
                  <HandHeart size={24} />
                </div>

                <p className="new-about-page-value-title">
                  Seva
                </p>

                <p className="new-about-page-value-description">
                  Turning inspiration into action by supporting needy individuals and organisations through our contributions.
                </p>

              </div>


              {/* ================= HERITAGE ================= */}

              <div
                className="new-about-page-value-card"
                data-aos="fade-up"
                data-aos-delay="400"
              >

                <div className="new-about-page-value-icon">
                  <Leaf size={24} />
                </div>

                <p className="new-about-page-value-title">
                  Heritage
                </p>

                <p className="new-about-page-value-description">
                  Preserving and sharing the timeless values, wisdom, and essence of Sanatana Dharma for generations to come.
                </p>

              </div>

            </div>


            {/* =================================================
                WRITE YOUR STORY
            ================================================== */}

            <div
              className="new-about-page-button-wrapper"
              data-aos="fade-up"
            >

              <button
                type="button"
                className="new-about-page-story-button"
                onClick={() => navigate("/createstory")}
              >
               Register Now
              </button>

            </div>

          </div>
        </section>

      </div>
    </>
  );
};

export default About;